export type HeaderItem = {
  id: string;
  parentId?: string;
  title: string;
  subtitle?: string;
  type?: string;
  url?: string;
  subItems?: HeaderItem[];
  image?: string;
  isNew?: boolean;
};
function formatHeaderItemsGraphql(input: any, parentId?: string): HeaderItem[] {
  return input.map((item: any) => {
    const headerItem: HeaderItem = {
      id: item.sys.id,
      title: item.title,
      parentId: parentId,
      subtitle: item.subtitle || undefined,
      type: item.type || undefined,
      url: item.url || undefined,
      image: item.icon?.url || undefined,
      isNew: item.isNew || undefined,
    };

    if (item.subItemsCollection && item.subItemsCollection.items) {
      headerItem.subItems = formatHeaderItemsGraphql(item.subItemsCollection.items, item.sys.id);
    }

    return headerItem;
  });
}

export { formatHeaderItemsGraphql };
